import PropTypes from "prop-types";
import classes from "../HeaderAvatarInfo/HeaderAvatarInfo.module.css";
import RoundImage from "../RoundImage";

const PageAvatarInfo = (props) => {
  return (
    <div className={classes.userInfo}>
      <RoundImage {...props}></RoundImage>
      <div className={classes.nameContainer}>
        <span className={classes.name}>{props.name}</span>
        <span>{props.extraDeatil}</span>
      </div>
    </div>
  );
};

PageAvatarInfo.propTypes = {
  name: PropTypes.string,
  extraDeatil: PropTypes.string,
  icon: PropTypes.string,
};

export default PageAvatarInfo;
